module.exports = __webpack_public_path__ + "img/EZ-Classroom-1.ead7def7.png";